import React, { useState } from 'react';
import { useNavigation } from '@react-navigation/native';
import { createGroupChannelListFragment } from '@sendbird/uikit-react-native';
import {
    withSendbirdConnection,
    ChatChannelList,
    ChatChannelListSkeleton,
    ChatChannelListEmpty,
    ChatListHeader,
    ChatListConnecting,
} from '../components';
import { ChatRetryContext } from '../contexts';
import { useChannelTitleResolver } from '../hooks/useChannelTitle';
import { IGroupChannelContentProps } from '../types';

const GroupChannelListFragment = createGroupChannelListFragment({
    Header: ChatListHeader,
    List: ChatChannelList,
    StatusLoading: ChatChannelListSkeleton,
    StatusEmpty: ChatChannelListEmpty,
});

const GroupChannelListContent: React.FC<IGroupChannelContentProps> = () => {
    const navigation = useNavigation<any>();
    const resolveTitle = useChannelTitleResolver();
    const [attempt, setAttempt] = useState(0);

    return (
        <>
            <ChatRetryContext.Provider value={() => setAttempt((value) => value + 1)}>
            <GroupChannelListFragment
                key={attempt}
                onPressCreateChannel={()=>{}}
                onPressChannel={channel => {
                    navigation.navigate('GroupChannel', { channelUrl: channel.url, channelName: resolveTitle(channel) });
                }}
                channelListQueryParams={{ includeEmpty: true }}
            />
            </ChatRetryContext.Provider>
        </>
    );
};

export const GroupChannelListScreen = withSendbirdConnection(
    GroupChannelListContent,
    {
        useDetailedConnectionStatus: true,
        ConnectingComponent: ChatListConnecting,
    }
);
